import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export const AccessDenied: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="d-flex flex-column flex-root">
      <div className="d-flex flex-column flex-center flex-column-fluid p-10">
        <img
          src="/assets/images/illustrations/sketchy-1/18.png"
          alt=""
          className="mw-400px"
        />
        <h1 className="fw-bold mb-10" style={{ color: '#A3A3C7' }}>
          {t('ACCESS_DENIED.TITLE')}
        </h1>
        <div className="fw-semibold fs-6 text-gray-500 mb-7">
          {t('ACCESS_DENIED.MESSAGE')}
        </div>
        <Link to="/orders/orders-list" className="btn btn-primary">
          {t('ACCESS_DENIED.GO_HOME')}
        </Link>
      </div>
    </div>
  );
};